// numberToWord.js
const a = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
];

const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function inWords(n) {
  if (n === 0) return '';
  
  if (n < 20) return a[n];
  if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
  if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + inWords(n % 100) : '');
  
  // 1,00,000 is 1 Lakh. Thousand limit is 99,999.
  if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
  
  // 1,00,00,000 is 1 Crore. Lakh limit is 99,99,999.
  if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
  
  // Anything above 1 Crore is grouped under Crores.
  return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
}

function numberToWord(num) {
  const val = parseFloat(num);
  if (isNaN(val) || val === 0) return 'Zero';
  
  const integerPart = Math.floor(val);
  const decimalPart = Math.round((val - integerPart) * 100);
  
  let words = inWords(integerPart);
  if (decimalPart > 0) {
    words += ' Point ' + decimalPart.toString().split('').map(d => a[parseInt(d)]).join(' ');
  }
  return words;
}

// Export the function
export default numberToWord;



